import { motion } from 'framer-motion';

export const StatCard = ({ title, value, icon: Icon, trend, trendValue, className = '' }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className={`stat-card bg-carbon border border-white/5 rounded-md p-3 sm:p-4 lg:p-6 shadow-lg ${className}`}
      data-testid={`stat-card-${title.toLowerCase().replace(/ /g, '-')}`}
    >
      <div className="flex items-start justify-between">
        <div className="flex-1 min-w-0">
          <p className="text-[10px] sm:text-xs uppercase tracking-wider text-slate-500 font-medium mb-1 sm:mb-2 truncate">{title}</p>
          <p className="text-lg sm:text-xl lg:text-3xl font-bold text-white mb-1 truncate">{value}</p>
          {trend && (
            <p className={`text-xs sm:text-sm ${trend === 'up' ? 'text-green-500' : 'text-red-500'}`}>
              {trendValue}
            </p>
          )}
        </div>
        {Icon && (
          <div className="w-8 h-8 sm:w-10 sm:h-10 lg:w-12 lg:h-12 bg-white/5 rounded-sm flex items-center justify-center flex-shrink-0 ml-2">
            <Icon className="w-4 h-4 sm:w-5 sm:h-5 lg:w-6 lg:h-6 text-electric-blue" />
          </div>
        )}
      </div>
    </motion.div>
  );
};

export default StatCard;
